import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { CheckCircle, Eye, Gift } from "lucide-react";
import ChartItem from "@dashboard/components/ChartItem";
import { apiSend, getRoute } from "@services/axios";
const Stats = ({ t, product_id }) => {
  const [dataConsultation, setDataConsultation] = useState({
    list: [],
    count: 0,
    growth: 0,
    status: "up",
  });
  const [dataBookingConfirmed, setDataBookingConfirmed] = useState({
    list: [],
    count: 0,
    growth: 0,
    status: "up",
  });
  const [dataBookingCanceled, setDataBookingCanceled] = useState({
    list: [],
    count: 0,
    growth: 0,
    status: "up",
  });

  useEffect(() => {
    (async () => {
      const response = await apiSend(
        [getRoute("PRODUCT_RETRIEVE"), product_id, "stat/dashboard"].join("/"),
        "get"
      );
      if (response?.data?.result) {
        setDataConsultation(response?.data?.result?.dataConsultation);
        setDataBookingConfirmed(response?.data?.result?.dataBookingConfirmed);
        setDataBookingCanceled(response?.data?.result?.dataBookingCanceled);
      }
    })();
  }, []);
  const data = [
    {
      title: t("seen"),
      count: dataConsultation.count,
      icon: <Eye size={25} strokeWidth={1.5} />,
      data: dataConsultation.list,
      color: "#8077EC",
      status: dataConsultation.status,
      growth: dataConsultation.growth,
    },
    {
      title: t("confirmeds"),
      count: dataBookingConfirmed.count + "%",
      icon: <CheckCircle size={25} strokeWidth={1.5} />,
      data: dataBookingConfirmed.list,
      color: "#16A571",
      status: dataBookingConfirmed.status,
      growth: dataBookingConfirmed.growth,
    },
    {
      title: t("cancelleds"),
      count: dataBookingCanceled.count + "%",
      icon: <Gift size={25} strokeWidth={1.5} />,
      data: dataBookingCanceled.list,
      color: "#FF5733",
      status: dataBookingCanceled.status,
      growth: dataBookingCanceled.growth,
    },
  ];

  return (
    <>
      <Row>
        {data.map((item) => (
          <Col md="6" lg="4" xl="12" className="my-2 pe-0">
            <ChartItem
              icon={item.icon}
              title={item.title}
              count={item.count}
              color={item.color}
              data={item.data}
              status={item.status}
              growth={item.growth}
            />
          </Col>
        ))}
      </Row>
    </>
  );
};

export default Stats;
